import { Fetch, Images } from '../../shared/types';
import { AuthType, ActionType, NeedResponse } from '../types';

export type ResultAction = {
  type: ActionType;
  key: string;
  name: string;
  noun: string;
  needs: NeedResponse[];
  meta: {
    bulk_action?: string;
    poll?: {
      can_paginate: true;
    };
  };
};

type Result = {
  selected_api: string;
  auth_type: AuthType;
  actions: ResultAction[];
  name: string;
  images: Images | null;
  primary_color: string;
};

type ResponseData = {
  results: Result[];
};

export type Implementation = Result & { images: Images };

export type Implementations = Record<string, Implementation>;

export const DEFAULT_IMAGES = {
  url_16x16:
    'https://cdn.zapier.com/zapier/images/frontend/placeholder/16x16.grey.png',
  url_32x32:
    'https://cdn.zapier.com/zapier/images/frontend/placeholder/32x32.grey.png',
  url_64x64:
    'https://cdn.zapier.com/zapier/images/frontend/placeholder/64x64.grey.png',
  url_128x128:
    'https://cdn.zapier.com/zapier/images/frontend/placeholder/128x128.grey.png',
};

const getImplementations = async (
  fetch: Fetch,
  ...selected_apis: string[]
): Promise<Implementations> => {
  const data = await fetch<ResponseData>('/api/v4/implementations/', {
    params: {
      selected_apis: selected_apis.join(','),
    },
  });

  return data.results.reduce((implementations, result) => {
    implementations[result.selected_api] = {
      ...result,
      images: result.images || DEFAULT_IMAGES,
    };
    return implementations;
  }, {} as Implementations);
};

export default getImplementations;
